import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';

//components
import FormLabel from '../Label';
import ErrorField from '../ErrorField';
//styles
import { FormGroup } from 'components/styled/Form.styled';
import { MultiSelect } from './index.styled';

const ChipsField = ({
  error,
  options,
  label,
  defaultValue,
  setFieldValue,
  name,
  isRequired,
  placeholder,
  value,
  hideValue,
}) => {
  return (
    <FormGroup>
      <FormLabel label={label} name={name} error={error} isRequired={isRequired}></FormLabel>
      <MultiSelect
        placeholder={placeholder}
        defaultValue={defaultValue}
        isMulti
        options={options}
        className="basic-multi-select"
        classNamePrefix
        onChange={option => setFieldValue(name, option)}
        error={error ? 'hasError' : 'noError'}
        value={value}
        hideValue={hideValue}
      />
      <ErrorMessage name={name} component={ErrorField} />
    </FormGroup>
  );
};

ChipsField.propTypes = {
  error: PropTypes.array,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    }),
  ),
  label: PropTypes.string,
  defaultValue: PropTypes.array,
  setFieldValue: PropTypes.func.isRequired,
  name: PropTypes.string,
  isRequired: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  hideValue: PropTypes.bool,
};

export default ChipsField;
